export interface langTypes {
    code: string,
    display: string
}
export const langDefaultList: langTypes[] = [
    { code: "ko",       display: "한국어" },
    { code: "en",       display: "English" },
]
export const sitelangs = ["ko", "en"]